import { Component, OnInit } from '@angular/core';
import { Company } from 'app/shared/models/company';
import { User } from 'app/shared/models/user';
import { Role } from 'app/shared/models/role';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';
import { CompanyService } from 'app/shared/services/company.service';

@Component({
  selector: 'app-company-new',
  templateUrl: './company-new.component.html',
  styleUrls: ['./company-new.component.css']
})
export class CompanyNewComponent implements OnInit {

  public Company:Company;
  public passwordChange:string;
  public confirmPassword:string;
  public isSaving:boolean;

  constructor(private companyService:CompanyService, private router:Router
    , private route:ActivatedRoute, private alertService:AlertService) { 
    this.Company = new Company();
    this.Company.user = new User();
    this.Company.user.role = Role.Owner;
  }

  ngOnInit() {
  }

  private validateForm() {
    let errors = [];
    if (!this.Company.name) {
      errors.push("You must enter a name for this company");
    }
    else if (this.Company.name.length < 3) {
      errors.push("Company must be at least 3 characters long");
    }

    if (!this.Company.email) {
      errors.push("You must enter a valid email for this company");
    }


    if (!this.passwordChange) {
      errors.push("You must enter in a password for the user for this company");
    }

    if (this.passwordChange != this.confirmPassword) {
      errors.push("The passwords don't match");
    }
    if (this.passwordChange && this.passwordChange.length < 8) { 
      errors.push("Password must be at least 8 characters");
    }
    return errors;
  }

  save() {
    let errors = this.validateForm();
    if (errors.length) {
      this.alertService.error(errors.join(".\n"), 3000);
      return;
    }
    this.isSaving = true;
    this.Company.user.password = this.passwordChange;
    this.companyService.createCompany(this.Company).then((company) => {
      this.router.navigate(['../', company.id, 'edit'], {replaceUrl: true, relativeTo: this.route});
    })
    .catch((error) => {
      console.error(error);
      this.isSaving = false;
      let msg = "Company failed to create.  Check server logs for details.";
      if (error.status == 400) {
        let json = error.json();
        if (json && json._code && json._code == 'DUP_ENTRY') {
          msg = "That username already exists in the system";
        }
      }
      this.alertService.error(msg);
    });
  }

  public setUserRole(role:Role) {
    this.Company.user.role = role;
  }

}



// WEBPACK FOOTER //
// ./src/app/companies-admin/company-new/company-new.component.ts